import { render } from "./HiiTPage.vue?vue&type=template&id=31a9f67e&scoped=true"
import script from "./HiiTPage.vue?vue&type=script&lang=js"
export * from "./HiiTPage.vue?vue&type=script&lang=js"

import "./HiiTPage.vue?vue&type=style&index=0&id=31a9f67e&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a9f67e"]])

export default __exports__